import { useStacklineTheme } from '@stackline/ui';
import React from 'react';
import StyledCheckbox from 'src/components/BeaconV2Components/common/StyledCheckbox';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';

export type SlCheckboxContainerProps = React.ComponentProps<typeof Flex>;

/**
 * Container for a group of checkboxes
 *
 * Usage:
 * ```
 * <SlCheckboxContainer>
 *  <SlCheckbox id="checkbox1" />
 *  <SlCheckboxLabel htmlFor="checkbox1">Checkbox 1</SlCheckboxLabel>
 * </SlCheckboxContainer>
 *```
 */
export function SlCheckboxContainer(props: SlCheckboxContainerProps) {
  return <Flex gap="sm" alignItems="center" {...props} />;
}

export type SlCheckboxProps = React.ComponentProps<typeof StyledCheckbox>;

/**
 * Checkbox component
 */
export const SlCheckbox = React.forwardRef<HTMLButtonElement, SlCheckboxProps>(function SlCheckbox(props, ref) {
  return <StyledCheckbox ref={ref} {...props} />;
});

export type SlCheckboxLabelProps = React.ComponentProps<'label'>;

/**
 * Label for a checkbox component
 */
export const SlCheckboxLabel = React.forwardRef<HTMLLabelElement, SlCheckboxLabelProps>(function SlCheckboxLabel(
  { style, ...rest },
  ref
) {
  const theme = useStacklineTheme();

  return (
    <label
      ref={ref}
      style={{
        width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: '14px',
        color: theme.colors.primary,
        cursor: 'pointer',
        ...style
      }}
      {...rest}
    />
  );
});
